var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sales-admin"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('SalesTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }